import axios from 'axios';
import {BE_SERVER_ENDPOINT, API_PROTOCOL} from '../constants/configs.js';
import {RECOMMENDATIONS_DATA_FETCHER_ACTIONS} from '../actions/recommendationsActions';
import { TIMESCALE } from '../constants/common.js';
import { RECO_DETAILS_ACTIONS } from '../actions/recoDetailsActions.js';
import { isPreview } from '../helpers/authHelper.js';

export function fetchTop5Reco(userId, locale, templateName){
    let params = {
        "locale": locale
    };
    if (isPreview()) {
        params.templateName = templateName
    }
    return dispatch => {
        axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/dashboard/users/' + userId + '/reco-feed-data', {
            params
        }).then(
            (response) => {
            dispatch({
                type: RECOMMENDATIONS_DATA_FETCHER_ACTIONS.FETCH_RECO_TOP_5,
                payload: response.data.payload
            })
        })
    }
}

export function fetchTipsToSaveEnergy(userId, measurementType, templateName, applianceId, locale, wholeHomeSelected) {
    let params = {
        "measurement-type": measurementType,
        "appliances": applianceId ? encodeURIComponent(applianceId) : null,
        "locale": locale,
        "keepNoApplianceReco": wholeHomeSelected,
        "show-only-tips" : true
    };
    if (isPreview()) {
        params.templateName = templateName
    }
    return dispatch => {
        axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/2.0/recommendations/users/' + userId + '/home/1', {
            params
        }).then(
            (response) => {
            dispatch({
                type: RECOMMENDATIONS_DATA_FETCHER_ACTIONS.FETCH_TIPS_TO_SAVE_ENERGY,
                payload: response.data.payload
            })
        })
    }
}

export function fetchRecoPrograms(userId, measurementType, locale, templateName) {
    let params = {
        "measurement-type": measurementType,
        "mode": TIMESCALE.YEAR,
        "locale": locale
    };
    if (isPreview()) {
        params.templateName = templateName
    }
    return dispatch => {
        axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/dashboard/users/' + userId + '/sponsored-reco-feed-data', {
            params
        }).then(
            (response) => {
                dispatch({
                    type: RECOMMENDATIONS_DATA_FETCHER_ACTIONS.FETCH_RECO_PROGRAMS,
                    payload: response.data.payload
                })
            }
        )
    }
}

export function fetchViewedRecos(userId, measurementType){
    return dispatch => {
        axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/dashboard/users/' + userId + '/module-tab-info', {
            "measurement-type": measurementType
        }).then(
            (response) => {
            dispatch({
                type: RECOMMENDATIONS_DATA_FETCHER_ACTIONS.SET_UNREAD_RECOS,
                payload: response.data.payload
            })
        })
    }
}

export function onViewRecos(userId, recoId, templateName) {
    let params = {};
    if (isPreview()) {
        params.templateName = templateName
    }
    return dispatch => {
        axios.post(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/dashboard/users/' + userId + '/reco-feed-data/' + recoId + '/viewed', {
            params
        }).then(
            () => {
                dispatch({
                    type: RECOMMENDATIONS_DATA_FETCHER_ACTIONS.SET_UNREAD_RECOS
                })
            }
        )
    }
}

export function onRecoLike(obj, index, templateName) {
    let params = {};
    if (isPreview()) {
        params.templateName = templateName
    }
    return dispatch => {
        axios.post(API_PROTOCOL + BE_SERVER_ENDPOINT + '/2.0/recommendation-feedback', obj, {
            params
        }).then(
            () => {
                dispatch({
                    type: RECOMMENDATIONS_DATA_FETCHER_ACTIONS.ON_RECO_LIKE,
                    payload: index
                })
            }
        )
    }
}

export function onRecoUnlike(userId, recoId, index, templateName) {
    let params = {};
    if (isPreview()) {
        params.templateName = templateName
    }
    return dispatch => {
        axios.delete(API_PROTOCOL + BE_SERVER_ENDPOINT + '/2.0/recommendation-feedback/users/' + userId + '/home/1/recommendation/' + recoId, {
            params
        }).then(
            () => {
                dispatch({
                    type: RECOMMENDATIONS_DATA_FETCHER_ACTIONS.ON_RECO_UNLIKE,
                    payload: index
                })
            }
        )
    }
}

export function fetchRecoDetails(options){
    let params = {
        locale: options.locale,
        "product-type": 'DEFAULT',
        "reco-id": options.recoId
    };
    if (isPreview()) {
        params.templateName = options.templateName;
    }
    let url = API_PROTOCOL + BE_SERVER_ENDPOINT;
    if (options.isPublic) {
        url += `/v2.0/public/pilot/${options.pilotId}/recommendation-details`;
    } else {
        url += `/2.0/recommendations/users/${options.userId}/recommendation-details`;
    }
    return dispatch => {
        axios.get(url, {
            params : params
        }).then(
            (response) => {
                dispatch({
                    type: RECO_DETAILS_ACTIONS.FETCH_DETAILS_SUCCESS,
                    payload : {
                        recoId : options.recoId,
                        details : response.data.payload.recommendationsMetaData.recommendationDetails,
                        metaData : response.data.payload
                    }
                 })
            }, error => {
                dispatch({
                    type: RECO_DETAILS_ACTIONS.FETCH_DETAILS_FAILURE,
                    payload : {
                        recoId : options.recoId
                    }
                })
            }
        )

    }
}